import { render, staticRenderFns } from "./DataTableVersoes.vue?vue&type=template&id=48475348&scoped=true&"
import script from "./DataTableVersoes.vue?vue&type=script&lang=js&"
export * from "./DataTableVersoes.vue?vue&type=script&lang=js&"
import style0 from "./DataTableVersoes.vue?vue&type=style&index=0&id=48475348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48475348",
  null
  
)

export default component.exports